var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 24,
    viewBox: "0 0 105 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4139_4810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3928 6.4262H35.6272V10.203H39.3928C41.2186 10.203 42.2836 9.28487 42.2836 8.31427C42.2836 7.34433 41.2186 6.4262 39.3928 6.4262ZM39.6971 14.3208H35.6272V20.9825H28.9707V2.30837H39.6971C45.707 2.30837 48.9401 5.24574 48.9401 8.31427C48.9401 11.3835 45.707 14.3208 39.6971 14.3208Z",
    fill: "#2D3B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7742 7.05573C63.2797 6.60978 62.3288 6.24253 61.1116 6.24253C59.8944 6.24253 58.9435 6.60978 58.449 7.05573C57.8404 7.60661 57.4601 8.23619 57.4601 11.6457C57.4601 15.0553 57.8404 15.6586 58.449 16.2095C58.9435 16.6555 59.8944 17.0483 61.1116 17.0483C62.3288 17.0483 63.2797 16.6555 63.7742 16.2095C64.3828 15.6586 64.7632 15.0553 64.7632 11.6457C64.7632 8.23619 64.3828 7.60661 63.7742 7.05573ZM68.6803 19.0413C66.703 20.4054 64.4202 21.1399 61.1116 21.1399C57.8024 21.1399 55.5202 20.4054 53.5423 19.0413C50.6895 17.0745 50.8036 14.452 50.8036 11.6457C50.8036 8.83888 50.6895 6.2163 53.5423 4.24953C55.5202 2.88544 57.8024 2.15093 61.1116 2.15093C64.4202 2.15093 66.703 2.88544 68.6803 4.24953C71.5331 6.2163 71.419 8.83888 71.419 11.6457C71.419 14.452 71.5331 17.0745 68.6803 19.0413Z",
    fill: "#2D3B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3032 6.4262H81.5382V10.203H85.3032C87.129 10.203 88.194 9.28487 88.194 8.31427C88.194 7.34433 87.129 6.4262 85.3032 6.4262ZM85.6075 14.3208H81.5382V20.9825H74.8811V2.30837H85.6075C91.6174 2.30837 94.8505 5.24574 94.8505 8.31427C94.8505 11.3835 91.6174 14.3208 85.6075 14.3208Z",
    fill: "#2D3B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5891 2.30849H104.246V20.9827H97.5891V2.30849Z",
    fill: "#2D3B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0837 6.28687C9.71428 6.28687 8.43217 7.62406 7.70947 8.80452C7.29106 9.51214 7.21499 10.2204 7.13892 10.8762H17.0285C16.9524 10.2204 16.8764 9.51214 16.458 8.80452C15.7353 7.62406 14.4276 6.28687 12.0837 6.28687Z",
    fill: "#2D3B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6743 12.8434H7.16668C7.41327 15.727 9.3243 17.434 12.6545 17.434C14.8226 17.434 15.8299 16.3972 17.3134 15.3748L19.2342 16.4169C17.7888 17.7311 15.7735 19.7294 12.5784 19.7294C7.63362 19.7294 4.40048 16.5074 4.40048 11.9436C4.40048 7.77397 7.28276 4.18669 12.0374 4.18669C16.8681 4.18669 19.6743 7.7556 19.6743 11.5849V12.8434ZM20.9859 10.8759H24.2013C23.5777 4.31785 18.4125 0 12.1325 0C5.43207 0 0 5.43732 0 12.1371C0 18.8381 5.43207 24 12.1325 24C18.4125 24 23.5777 19.4015 24.2013 12.8434H20.9859V10.8759Z",
    fill: "#2D3B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4139_4810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.245,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d46c25ea1de0662003aeca532e66619d.svg";
export { ForwardRef as ReactComponent };